export const PROPERTIES = {
  WCA: 'Atmore',
  WCM: 'Montgomery',
  WCW: 'Wetumpka',
  WCB: 'Bethlehem',
  WCI: 'Chicago Southland',
  ACC: 'Aruba Crystal',
  ASP: 'Aruba Seaport Casino',
  CCC: 'Curacao Carnival Casino',
  CEG: 'Gretna',
  MGR: 'Mobile',
  WSS: 'Wa She Shu'
};

export const PROPERTY_SLUGS = {
  WCA: 'atmore',
  WCM: 'montgomery',
  WCW: 'wetumpka',
  WCB: 'bethlehem',
  WCI: 'chicagosouthland',
  ACC: 'aruba',
  ASP: 'aruba',
  CCC: 'curacao',
  CEG: 'gretna',
  MGR: 'mobile',
  WSS: 'wa-she-shu'
};

// These are now pulled from the roomTypeDescription field
/*
export const ROOM_TYPES = {
  // Montgomery
  DKN:  'Deluxe King Non-Smoking',
  DKNA: 'Deluxe King Accessible Non-Smoking',
  DQN:  'Deluxe Queen Non-Smoking',
  DQNA: 'Deluxe Queens Non-Smoking Accessible',
  SKN:  'Suite King Non-Smoking',
  SKNA: 'Suite King Non-Smoking Accessible',

  // Atmore
  UKS: 'Ultra King Smoking',
  AQN: 'Accessible Q/Q Non-Smoking',
  AQS: 'Accessible Queen Smoking',
  CQN: 'Deluxe Q/Q Non-Smoking',
  CQS: 'Deluxe Q/Q Smoking',
  DQN: 'Deluxe Q/Q Non-Smoking',
  DQS: 'Deluxe Q/Q Smoking',

  // Wetumpka
  RKN:  'Standard King Non-Smoking',
  AQS:  'Accessible Queen Smoking',
  SKN:  'Corner Suite Non-Smoking',
  SKS:  'Corner Suite Smoking',
  AQN:  'Accessible Queen Non-Smoking',
  SKNA: 'Accessible Corner Suite Non Smoking',
  DQS:  'Deluxe Queen Smoking',
  PKN:  'Platinum Suite Non-Smoking',
  DQN:  'Deluxe Queen Non-Smoking',
  AKN:  'Accessible King Non-smoking',
  PKS:  'Platinum Suite Smoking',
  AKS:  'Accessible King Smoking',
  DKS:  'Deluxe King Smoking',
  DKN:  'Deluxe King Non-Smoking',
  PKNA: 'Accessible Platinum Suite Non Smoking',

  // Bethlehem
  CK: 'Chairman Deluxe King',
  DK: 'Deluxe King',
  SK: 'Smoking Deluxe King',
  AK: 'Handicap Accessible Deluxe King',
  S1: 'Handicap Accessible Smoking Deluxe King',
  DQ: 'Deluxe Queen',
  SQ: 'Smoking Deluxe Queen',
  AQ: 'Handicap Accessible Deluxe Queen',
  S2: 'Handicap Accessible Smoking Deluxe Queen',
  CE: 'Chairman Executive',
  AS: 'Chairman Executive Suite Accessible',
  EK: 'Executive Suite',
  AE: 'Handicap Accessible Executive Suite',
  SE: 'Smoking Executive Suite',
  CP: 'Chairman Presidential',
  CS: 'Chairman Suite',
  PK: 'Presidential Suite',
  AP: 'Handicap Accessible Presidential Suite',
  SP: 'Smoking Presidential Suite'
};
*/

export class HotelReservations {
  // Converts dates from the WindCreek API to a format that the Date constructor can understand
  static getDate(reservation) {
    //let checkIn = reservation.checkedIn.replaceAll('/', '-').replace(' ', 'T') + 'Z';
    //let checkOut = reservation.checkedOut.replaceAll('/', '-').replace(' ', 'T') + 'Z';

    let checkIn = reservation.startDate + 'T00:00:00Z';
    let checkOut = reservation.endDate + 'T00:00:00Z';

    return {
      checkIn: new Date(checkIn),
      checkOut: new Date(checkOut)
    };
  }

  // Returns an object with the reservations grouped by their status, either current or past
  static groupByStatus(reservations) {
    let currentStatuses = [
      'RESERVED',
      'PROSPECT',
      'INHOUSE',
      'CHANGED',
      'WAITLISTED',
      'PRECHECKEDIN',
      'DUEOUT',
      'DUEIN',
    ];

    let pastStatuses = [
      'NOSHOW',
      'CANCELED',
      'CHECKEDOUT',
    ];

    let result = {
      current: [],
      past: []
    };

    reservations.forEach(reservation => {
      if (currentStatuses.includes(reservation.status)) {
        result.current.push(reservation);
      } else {
        result.past.push(reservation);
      }
    });

    return result;
  }
}
